import { WebApiModelsMemberField } from "../Repository/eventbookyapi";
import { TextService } from "../Services/TextService";
import { MemberFieldTypes } from "../Types/MemberFieldTypes"

export const mapDynamicInputLabel = (type: MemberFieldTypes, fieldSettings: WebApiModelsMemberField[] | null, fieldId: number | undefined | null) => {
    const GetText = TextService.GetText;

    let setting: WebApiModelsMemberField | undefined;
    if (type === MemberFieldTypes.Custom && fieldId != null) {
        setting = fieldSettings?.find(
            p => (p.id === fieldId || (p as any).fieldId === fieldId)
        );
    } else {
        setting = fieldSettings?.find(p => p.columnType == type);
    }

    const hasNameAdmin = setting?.nameAdmin;

    switch (type) {
        case MemberFieldTypes.UniqueId:
            return GetText("EditMember_UniqueId");
        case MemberFieldTypes.FirstName:
            return GetText("EditMember_FirstName");
        case MemberFieldTypes.LastName:
            return GetText("EditMember_LastName");
        case MemberFieldTypes.Email:
            return GetText("EditMember_Email");
        case MemberFieldTypes.Email2:
            return GetText("EditMember_Email2");
        case MemberFieldTypes.PhoneNumber:
            return GetText("EditMember_PhoneNumber");
        case MemberFieldTypes.Address:
            return GetText("EditMember_Address");
        case MemberFieldTypes.PostalCode:
            return GetText("EditMember_PostalCode");
        case MemberFieldTypes.PostalArea:
            return GetText("EditMember_PostalArea");
        case MemberFieldTypes.Title:
            return GetText("EditMember_Title");
        case MemberFieldTypes.Country:
            return GetText("EditMember_Country");
        case MemberFieldTypes.Company:
            return GetText("EditMember_Company");
        case MemberFieldTypes.Extra1:
            return hasNameAdmin ? hasNameAdmin : GetText("EditMember_Extra1");
        case MemberFieldTypes.Extra2:
            return hasNameAdmin ? hasNameAdmin : GetText("EditMember_Extra2");
        case MemberFieldTypes.Extra3:
            return hasNameAdmin ? hasNameAdmin : GetText("EditMember_Extra3");
        case MemberFieldTypes.Status:
            return GetText("EditMember_Status");
        case MemberFieldTypes.Group:
            return GetText("EditMember_Groups");
        case MemberFieldTypes.EmailNotificationPreference:
            return GetText("EditMember_EmailNotificationPreference");
        case MemberFieldTypes.PersonalNumber:
            return GetText("EditMember_PersonalNumber");
        case MemberFieldTypes.PhoneNumber2:
            return GetText("EditMember_PhoneNumber2");
        case MemberFieldTypes.AdressRow2:
            return GetText("EditMember_AdressRow2");
        case MemberFieldTypes.AdressRow3:
            return GetText("EditMember_AdressRow3");
        case MemberFieldTypes.JoinedDate:
            return GetText("EditMember_JoinedDate");
        case MemberFieldTypes.WebPage:
            return GetText("EditMember_WebPage");
        case MemberFieldTypes.Payment:
            return GetText("EditMember_Payment");
        case MemberFieldTypes.Membership:
            return GetText("EditMember_Membership");
        case MemberFieldTypes.MembershipAddon:
            return GetText("EditMember_MembershipAddon");
        case MemberFieldTypes.Custom:
            return setting?.nameAdmin
        default:
            return "Unknown";
    }
}


